import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  cancelConfiguration, setActiveStep, preSaveConfiguration, setSoftwareSelection,
} from '../../configuration-management/ducks';
import { openModal, closeModal } from '../../modals/ducks';
import { stepsConfig, configurationStatuses, softwareStepsConfig } from '../../../constants';
import { getSoftwareStepperLabels } from '../../../utils/linear-stepper';
import I10n from '../../../features/i10n';
import Configuration from '../../../models/Configuration';
import { setApplicationParameters } from '../../../utils/application-parameters/ducks';
import { appConfiguration } from '../../../utils/app-starter';
import ApplicationFullHeader from '../../../components/application_full_header';
import Scrollbars from 'react-custom-scrollbars';
import { buildMySchneiderUrl } from '../../../utils/url-builder';
import { getLicenceSelectorSoftwares } from './ducks';
import { removeHandleDefaultSearchParameters } from '../head_device_selector_screen/ducks';
import { resetCBRSelectedItems, setCBRSelectedItems } from '../../call-by-range/ducks';
import { logDeleteCBRFilterEvent } from '../../../utils/analytics-logger';
import Notification from '../../notification';
import { showNotificationWithButton } from '../../notification/ducks';
import SoftwareSelectionScreenContent from '../../../components/software_licence/software_selection_screen_content';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 2em);
  overflow-x: hidden;
  background-color: #F4F4F4;

  @media (max-width: 800px) {
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    overflow: auto;
    padding: 0px;
  }
  ${props => props.fullScreenEnabled && `
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    overflow: auto;
    padding: 0px;
  `}
`;

const FullScreenScrollbarWrapper = styled.div`
`;

const ScreenContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0px 16px 0px 16px;
  ${props => props.fullScreenEnabled && `
  `}
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  padding-top: 20px;
`;

const MainContentWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
`;

class SoftwareSelectionScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isDesktop: window.innerWidth > 800,
      softwareGroups: [],
      filters: [],
      softwaresLoading: false,
    };
    this._isMounted = false;
  }

  updateIsDesktop = () => {
    if (this.state.isDesktop && window.innerWidth <= 800) {
      this.setState({ isDesktop: false });
    } else if (!this.state.isDesktop && window.innerWidth > 800) {
      this.setState({ isDesktop: true });
    }
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.updateIsDesktop);
    this._isMounted = true;
    this.getLicenceSelectorSoftwares((softwareGroups) => {
      const selectedSoftwares = this.props.callByRangeReducer?.selectedItems?.ranges ? Object.keys(this.props.callByRangeReducer.selectedItems.ranges) : [];
      const selectedReferences = this.props.callByRangeReducer?.selectedItems?.references ? Object.keys(this.props.callByRangeReducer.selectedItems.references) : [];

      const allSoftwares = [];
      for (const softwareGroup of softwareGroups) {
        for (const software of softwareGroup.softwares) {
          allSoftwares.push(software.key);
        }
      }
      // If there was a call by range and if the call by range gives us only one software
      if ((selectedSoftwares.length > 0 || selectedReferences.length > 0) && allSoftwares.length === 1) {
        this.props.setSoftwareSelection(allSoftwares[0]);
      }
    });
    this.props.removeHandleDefaultSearchParameters();
  }

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateIsDesktop);
    this._isMounted = false;
    this.props.closeModal();
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  showDuplicateConfirmationModal = (callback) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    if (isSaved && !this.props.configuration.allowSavedModifications) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => {
            this.props.closeModal();
            callback();
          },
          title: I10n.get('modal.change_saved_configuration.title'),
          text: I10n.get('modal.change_saved_configuration.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      callback();
    }
  }

  renderMainSection = () => {
    return (
      <ContentWrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <SoftwareSelectionScreenContent
          softwareGroups={this.state.softwareGroups}
          filters={this.state.filters}
          softwaresLoading={this.state.softwaresLoading}
          setSoftwareSelection={(softwareSelection) => {
            const newSoftwareSelection = softwareSelection.key;
            if (newSoftwareSelection !== this.props.configuration.softwareSelection) {
              this.showDuplicateConfirmationModal(() => {
                if (this.props.configuration.softwareSelection == null) {
                  this.props.setSoftwareSelection(newSoftwareSelection);
                } else {
                  this.props.openModal({
                    modalType: 'confirmation',
                    modalProps: {
                      onCancel: () => { this.props.closeModal(); },
                      onSubmit: () => {
                        this.props.closeModal();
                        this.props.setSoftwareSelection(newSoftwareSelection);
                      },
                      title: I10n.get('screen.config_editor.modal_new_configuration.title'),
                      text: I10n.get('screen.config_editor.modal_new_software_licence_configuration.body'),
                      cancelText: I10n.get('app.action.no'),
                      submitText: I10n.get('app.action.yes'),
                    }
                  });
                }
              });
            } else {
              if (configurationStatuses.finished === this.props.configuration.status) {
                this.props.setActiveStep(softwareStepsConfig.licence_selector);
              } else {
                this.props.preSaveConfiguration(this.props.configuration, softwareStepsConfig.licence_selector).then(() => {
                }).catch(() => { });
              }
            }
          }}
          isSaving={this.props.configurationSaver.isSaving}
        >
        </SoftwareSelectionScreenContent>
      </ContentWrapper >
    );
  }

  confirmationBeforeCancel = (isSaved, cancelCallback) => {
    if (!isSaved) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            cancelCallback();
            this.props.cancelConfiguration(this.props.configuration.id);
            this.props.closeModal();
          },
          title: I10n.get('screen.config_editor.modal_cancel.title'),
          text: I10n.get('screen.config_editor.modal_cancel.body'),
          cancelText: I10n.get('app.action.return'),
          submitText: I10n.get('app.action.confirm'),
        }
      });
    } else {
      cancelCallback();
    }
  }

  getStepperActions = (isSaved) => {
    const config = new Configuration(this.props.configuration);

    return [
      { action: () => {}, active: true, done: this.props.configuration.softwareSelection != null || isSaved },
      { action: () => {
        if (configurationStatuses.finished === config.status) {
          this.props.setActiveStep(softwareStepsConfig.licence_selector);
        } else {
          this.props.preSaveConfiguration(this.props.configuration, softwareStepsConfig.licence_selector).then(() => {
          }).catch(() => { });
        }
      }, active: this.props.configuration.softwareSelection != null, done: isSaved },
      { action: () => {
        if (configurationStatuses.finished === config.status) {
          this.props.setActiveStep(softwareStepsConfig.service_plan);
        } else {
          this.props.preSaveConfiguration(this.props.configuration, softwareStepsConfig.service_plan).then(() => {
          }).catch(() => { });
        }
      }, active: this.props.configuration.softwareLicences?.length > 0,
       hidden: this.props.configuration.servicePlanItems?.length === 0,
       done: isSaved },
      {
        action: () => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.setActiveStep(stepsConfig.save_screen);
          } else {
            this.props.saveConfiguration(this.props.configuration).then(() => {
              this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
            }).catch(() => { });
            this.props.closeModal();
          }
        }, active: this.props.configuration.softwareLicences?.length > 0 || isSaved, done: isSaved
      },
    ];
  }

  setWrapperRef = element => {
    this.wrapperElement = element;
  };

  getLicenceSelectorSoftwares = (successCallback) => {
    this.updateStateIfMounted({softwaresLoading: true});
    this.props.getLicenceSelectorSoftwares().then((response) => {
      const softwareGroups = response.softwareGroups;
      this.updateStateIfMounted({softwareGroups, filters: response.filters});
      if (successCallback) {
        successCallback(softwareGroups);
      }
    }).finally(() => {
      this.updateStateIfMounted({softwaresLoading: false});
    });
  }

  clearCBRCategory = (category) => {
    this.props.openModal({
      modalType: 'confirmation',
      modalProps: {
        onCancel: () => { this.props.closeModal(); },
        onSubmit: () => {
          const newValue = JSON.parse(JSON.stringify(this.props.callByRangeReducer));
          if (newValue.selectedItems[category]) {
            newValue.selectedItems[category] = {};
          }
          this.props.setCallByRangeSelectedItems(newValue);
          logDeleteCBRFilterEvent(this.props.configuration?.id, softwareStepsConfig.software_selection, category);
          this.getLicenceSelectorSoftwares(() => {});
          this.props.closeModal();
        },
        title: I10n.get('screen.start_configuration_screen.cbr.modal.delete_filter.title'),
        text: I10n.get('screen.start_configuration_screen.cbr.modal.delete_filter.body'),
        cancelText: I10n.get('app.action.cancel'),
        submitText: I10n.get('app.action.apply'),
      }
    });
  }

  renderScreenContent = (config) => {
    return (
      <>
        <ScreenContent fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
          <MainContentWrapper ref={this.setWrapperRef}>
            {this.renderMainSection()}
          </MainContentWrapper>
          <Notification>
          </Notification>
        </ScreenContent>
      </>
    );
  }

  renderWithEventualScrollBar = (screenContent) => {
    return ((this.state.isDesktop && !this.props.applicationParameters.fullScreenEnabled) ? <>{screenContent}</> : <Scrollbars>
      <FullScreenScrollbarWrapper>
        {screenContent}
      </FullScreenScrollbarWrapper>
    </Scrollbars>);
  }

  render = () => {
    const config = new Configuration(this.props.configuration);
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    return (
      <Wrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <ApplicationFullHeader
          title={I10n.get('app.licence_selector.title')}
          fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
          shouldShowLogin={appConfiguration.seamlessSession == null}
          setApplicationParameters={this.props.setApplicationParameters}
          userName={appConfiguration.seamlessSession?.name}
          goToStartPage={
            () => {
              this.confirmationBeforeCancel(isSaved, this.props.backToStart);
            }}
          applicationParameters={this.props.applicationParameters}
          steps={getSoftwareStepperLabels()}
          activeStep={softwareStepsConfig.software_selection}
          stepperActions={this.getStepperActions(isSaved)}
          selectedCriteria={this.props.callByRangeReducer?.selectedItems || {}}
          clearCategory={this.clearCBRCategory}
          openModal={this.props.openModal}
          closeModal={this.props.closeModal}
          disabled={this.props.configurationSaver.isSaving}
          redirectWithCBR={false}
          mySchneiderLink={buildMySchneiderUrl()}
          isSoftwareLicenseConfiguration={true}
        ></ApplicationFullHeader>
        {this.renderWithEventualScrollBar(this.renderScreenContent(config))}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal()),
    preSaveConfiguration: (configuration, step) => dispatch(preSaveConfiguration(configuration, configurationStatuses.finalized, step)),
    saveConfiguration: (configuration) => dispatch(preSaveConfiguration(configuration)),
    setApplicationParameters: (parameters) => dispatch(setApplicationParameters(parameters)),
    backToStart: () => dispatch(setActiveStep(stepsConfig.start_screen)),
    cancelConfiguration: (configId) => dispatch(cancelConfiguration(configId)),
    setActiveStep: (step) => dispatch(setActiveStep(step)),
    setSoftwareSelection: (softwareSelection) => dispatch(setSoftwareSelection(softwareSelection, softwareStepsConfig.licence_selector)),
    getLicenceSelectorSoftwares: () => dispatch(getLicenceSelectorSoftwares()),
    removeHandleDefaultSearchParameters: () => dispatch(removeHandleDefaultSearchParameters()),
    setCallByRangeSelectedItems: (items) => dispatch(setCBRSelectedItems(items)),
    resetCallByRangeSelectedItems: () => dispatch(resetCBRSelectedItems()),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text, type, buttonElement))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SoftwareSelectionScreen);
